import { AppRoutes } from "./Pages/Router";

export default function App() {
  return <AppRoutes />;
}
